import { Component, OnInit } from '@angular/core';
import { Boleto } from '../models/Boleto';
import { HomeService } from '../home/services/home.service';
import * as $ from 'jquery';
import { SessionstorageService } from '../services/sessionstorage.service';
import { LocalstorageService } from '../services/localstorage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TimerService } from '../timer/timer.service';
import { Subscription } from 'rxjs';
import { SeleccionGeneral } from '../models/SeleccionGeneral';
declare var $: any;

@Component({
  selector: 'app-buenfin',
  templateUrl: './buenfin.component.html',
  styleUrls: ['./buenfin.component.scss']
})

export class BuenfinComponent implements OnInit {
  /* Variables */
  flagGirar = false;
  flag_buy = false;
  flag_buy_loader = false;
  flag_buy_btn = false;
  boleto_disponible = 1;


  public boleto: Boleto;
  private info_boleto: Array<Object> = [];
  private precio_boleto: number = 0;
  private pkcolab: string;

  public mensajeError: string = '';
  Error: boolean = false;
  public boletosLuck: Array<Boleto> = [];
  public boletosLuckfil: Array<Boleto> = [];
  public boletos: Array<Object> = [];
  public box: any;
  public metodo: boolean = false;
  botonDisabled: boolean = true;
  boton: boolean = false;


  /* cariables girar tombola */



  /* input */

  inputDisabled_1: boolean = true;
  inputDisabled_2: boolean = true;
  inputDisabled_3: boolean = true;
  inputDisabled_4: boolean = true;
  option_1: string = '';
  option_2: string = '';
  option_3: string = '';
  option_4: string = '';



  /* carrito */

  public boleto_: Array<Object> = [];
  private boletos_generados: Array<Object> = [];
  private tipos_pago: number = 1;
  public checkC: number = 0;
  private miSeleccion: SeleccionGeneral = { numero: '', mecanismo: '', data: '' };
  PopBoleto: boolean = false;
  ErrorSuerte: boolean = false;
  contlck: number = 3;
  public subsasdas: Subscription;


  constructor(
    private _HomeService: HomeService,
    private _session: SessionstorageService,
    private _local: LocalstorageService,
    private router: Router,
    private st: TimerService,
    private route: ActivatedRoute,


  ) { }

  ngOnInit(): void {
    sessionStorage.setItem('texto', 'Estás ayudando a formar líderes del mañana, ¡Gracias por confiar en Sorteo Anáhuac!');
    sessionStorage.setItem('Anahuac online ', 'true');
    sessionStorage.setItem('url', 'home-egresados');
    // const header = document.getElementById('main-header');
    // if (header) {
    //   header.style.display = 'none';
    // }
  }

  getBoletoRandom() {
    //guardar tipo boleto
    sessionStorage.setItem('tipoBoleto', 'Maquina de la suerte ventas cruzadas');

    this.botonDisabled = false;
    this.metodo = true;
    this.box = document.getElementById('ListBol');
    this.box.hidden = true;

    this.boletos = [];
    this.boletosLuck = [];
    this.mensajeError = '';
    this.Error = false;
    // false = Habilitado | true = Desabilitado
    this.inputDisabled_1 = true;
    this.inputDisabled_2 = true;
    this.inputDisabled_3 = true;
    this.inputDisabled_4 = true;
    this.option_1 = '';
    this.option_2 = '';
    this.option_3 = '';
    this.option_4 = '';

    this.boleto_disponible = 1;

    /*nuevo */
    this.flag_buy = true;
    this.flag_buy_loader = true;
    this.flag_buy_btn = false;
    //////console.log("Entra getBoletoRandom");
    var pkc = { pkcolab: this.pkcolab };
    //console.log("pk_colaboradro"+this.pkcolab);
    //47F422062D08C8FA6F726F7E0FF5E1C57D903CA62BD39006
    this._HomeService.getBoletosGeneral("47F422062D08C8FA6F726F7E0FF5E1C57D903CA62BD39006").subscribe(
      (data: Boleto[]) => {
        if (data.length == 0) {

          return 0;
        } else {
          // this.MsgInvisible();
        }
        //////console.log("ONE --", this.boleto);
        if (this.flagGirar) this.deleteNumbers(this.boleto.folio.toString().split(""));

        this.boleto = data[0];
        //////console.log("TWO", this.boleto);
        this.precio_boleto = data[0].costo;

        this.info_boleto = [];
        //////console.log("Aquiiiiiii", this.info_boleto);


        //////console.log("THREE", data[0].folio);


        //////console.log(this.boleto.folio);
        this.girar();

        //////console.log(this.info_boleto);
        if (data[0].folio == null || data[0].folio.toString() === '') {

        }
      },
      (err) => {
        console.error(err);
      },
      () =>
      //////console.log('done loading boletos')
      { }
    );
  }


  deleteNumbers(numerosBoletos) {
    for (let i = 0; i < 6; i++) {
      let number = numerosBoletos[i];
      for (let index = 0; index <= parseInt(number); index++) {
        $("#list-n" + i + " li:last").remove();
      }
      $("#list-n" + i).removeClass("animation-list" + i);
    }
  }


  girar() {
    let boleto = this.boleto.folio.toString();
    let numerosBoletos = boleto.split("");

    setTimeout(() => {

      for (let i = 0; i < 6; i++) {
        let number = numerosBoletos[i];
        let lis = "";
        let sizePx = 40;
        for (let index = 0; index <= parseInt(number); index++) {
          lis += "<li>" + index + "</li>";
        }

        $("#list-n" + i).append(lis);

        sizePx *= parseInt(number);
        sizePx = -760 - sizePx - 40;
        //////console.log(sizePx);
        document.documentElement.style
          .setProperty('--my-start-px' + i, sizePx + "px");
        $("#list-n" + i).addClass("animation-list" + i);
      }
      setTimeout(() => {
        this.flag_buy_loader = false;
        this.flag_buy_btn = true;
        this.flag_buy = false;
      }, 5500);
    }, 100);


    this.flagGirar = true;


  }


  inputDisabled(opcion) {
    this.box = document.getElementById('ListBol');
    if (opcion == 1) {
      this.inputDisabled_1 = false;
      this.inputDisabled_2 = true;
      this.inputDisabled_3 = true;
      this.inputDisabled_4 = true;
      this.boletos = [];
      this.option_2 = '';
      this.option_3 = '';
      this.option_4 = '';
      this.Error = false;
      this.box.hidden = true;
    } else if (opcion == 2) {
      this.inputDisabled_1 = true;
      this.inputDisabled_2 = false;
      this.inputDisabled_3 = true;
      this.inputDisabled_4 = true;
      this.boletos = [];
      this.option_1 = '';
      this.option_3 = '';
      this.option_4 = '';
      this.Error = false;
      this.box.hidden = true;
    } else if (opcion == 3) {
      this.inputDisabled_1 = true;
      this.inputDisabled_2 = true;
      this.inputDisabled_3 = false;
      this.inputDisabled_4 = true;
      this.boletos = [];
      this.option_1 = '';
      this.option_2 = '';
      this.option_4 = '';
      this.Error = false;
      this.box.hidden = true;
    } else if (opcion == 4) {
      this.inputDisabled_1 = true;
      this.inputDisabled_2 = true;
      this.inputDisabled_3 = true;
      this.inputDisabled_4 = false;
      this.boletos = [];
      this.boletosLuck = [];
      this.option_1 = '';
      this.option_2 = '';
      this.option_3 = '';
      this.Error = false;
      this.box.hidden = true;
    }
  }

  efectuarPago() {

    this.boleto_ = null;


    var ls = this._local.getBoletosGenerados();
    this.boletos_generados = ls == null ? [] : JSON.parse(ls);
    this._session.setBoletosCol(0);
    // Si metodo=true y btnElegir es igual al parametro que mando el boton Agregar a Carrito, inserta add-cart!
    if (this.metodo) {
      var date = new Date();
      this._local.setFechaInicio(date);
      this._local.setFechaFin(date);

      this.boletos_generados.push(this.boleto);

      this._local.setBoletosGenerados(this.boletos_generados);

      this.st.startTimer();
      this._session.setTiposPago(this.tipos_pago);
      sessionStorage.setItem('pagina', 'Home');
      sessionStorage.setItem('tipoBoleto', 'Maquinita Suerte');
      sessionStorage.setItem('texto', 'Gracias por participar en nuestro Sorteo');
      this.router.navigate(['carrito-compra']);
    } else if (!this.metodo) {
      // this._local.getBoletosGenerados() = ;

      var date = new Date();
      this._local.setFechaInicio(date);
      this._local.setFechaFin(date);
      var info_bol = this.boletos.filter((boleto) => boleto['marcado'] === true);
      //////console.log("Infor de boletos", info_bol)
      info_bol.forEach((element) => {
        //////console.log("ciclando boleto: ", element);
        //////console.log("Conteo existe boleto: ", this.boletos_generados.filter(bol => bol["folio"] === element["folio"]).length);
        if (this.boletos_generados.filter((bol) => bol['folio'] === element['folio']).length == 0) {
          //////console.log("Agregando boleto:", element);
          this.boletos_generados.push(element);
        }
      });
      this._local.setBoletosGenerados(this.boletos_generados);

      this.st.startTimer();
      this._session.setTiposPago(this.tipos_pago);
      sessionStorage.setItem('pagina', 'Home');
      sessionStorage.setItem('tipoBoleto', 'Modal folios ');
      sessionStorage.setItem('texto', 'Gracias por participar en nuestro Sorteo');
      this.router.navigate(['carrito-compra']);
    }
    this.metodo = false;
  }

  btnable(check) {
    if (check) {
      this.checkC++;
    } else {
      this.checkC--;
    }
    if (this.checkC > 0) {
      this.botonDisabled = false;
    } else {
      this.botonDisabled = true;
    }
  }

  Registrobol(boleto) {
    this.SetLuckyBoleto(boleto);
    //this.offbtnMas();
  }

  SetLuckyBoleto(boletol) {
    if (boletol != '') {
      this.miSeleccion = { numero: boletol, mecanismo: 'option_termination', data: "47F422062D08C8FA6F726F7E0FF5E1C57D903CA62BD39006" };
      this._HomeService.getLuckyBol(this.miSeleccion).subscribe((data) => {
        //////console.log("No boletos");
        //////console.log(data.length)
        //////console.log("Boletos")
        //////console.log(data);
        if (data.length == 0) {
          //Si no hay boletos disponibles
          this.boletosLuck = data;
          data = '';
          this.mensajeError = 'Desafortunadamente el boleto(s) ya está reservado(s). Intenta con otro.';
          this.PopBoleto = false;
          this.Error = true;
          this.ErrorSuerte = false;
        } else if (data[0].clave == 0) {
          //Si el boleto no existe
          this.boletosLuck = data;
          data = '';
          this.mensajeError = 'Desafortunadamente el boleto no existe. Intenta con otro.';
          this.PopBoleto = false;
          this.Error = true;
          this.ErrorSuerte = false;
        } else if (data[0].clave == 1 && data[0].folio == 'Reservado') {
          //Si el boleto está reservado
          this.boletosLuck = data;
          data = '';
          this.mensajeError = 'Desafortunadamente el boleto(s) ya está reservado(s). Intenta con otro.';
          this.PopBoleto = false;
          this.Error = true;
          this.ErrorSuerte = false;
        } // Si encuentra boletos para registrar
        else {
          this.boletosLuck = data;
          this.boletosLuckfil = this.boletosLuck.filter((item, index) => index < 3);
          this.Error = false;
          this.PopBoleto = true;
          this.contlck = 3;
          //////console.log("Correcto");
        }
      });
    } else {
      this.PopBoleto = false;
    }
  }

  getLuckyBoleto(opcion1, opcion2, opcion3, opcion4) {
    //this.botonDisabled = false;

    this.metodo = false;
    this.mensajeError = '';
    this.Error = false;
    this.box = document.getElementById('ListBol');

    if (opcion1 != '') {
      this.miSeleccion = { numero: opcion1, mecanismo: 'option_termination', data: "47F422062D08C8FA6F726F7E0FF5E1C57D903CA62BD39006" };
      this._HomeService.seleccioGeneral(this.miSeleccion).subscribe((data) => {
        ////console.log(data);
        if (data.length == 0) {
          this.boletos = data;
          data = '';
          this.mensajeError = 'Boleto(s) no disponible(s)';
          this.Error = true;
          this.box.hidden = false;
        } else {
          this.boletos = data;
          this.box.hidden = false;
        }
      });
      //////console.log("Seleccione opcion 1")
    } else if (opcion2 != '') {

      this.miSeleccion = { numero: opcion2, mecanismo: 'option_contains', data: "47F422062D08C8FA6F726F7E0FF5E1C57D903CA62BD39006" };
      this.subsasdas = this._HomeService.seleccioGeneral(this.miSeleccion).subscribe(
        // this._HomeService.seleccioGeneral(this.miSeleccion).subscribe(
        (data) => {
          ////console.log(data);

          if (data.length == 0) {
            this.boletos = data;
            data = '';
            this.mensajeError = 'Boleto(s) no disponible(s)';
            this.Error = true;
            this.box.hidden = false;
          } else {
            this.boletos = data;
            //////console.log(JSON.stringify(data))
            this.box.hidden = false;
          }
        }
      );
      //////console.log("Seleccione opcion 2")
    } else if (opcion3 != '') {

      this.miSeleccion = { numero: opcion3, mecanismo: 'option_starts', data: "47F422062D08C8FA6F726F7E0FF5E1C57D903CA62BD39006" };
      this._HomeService.seleccioGeneral(this.miSeleccion).subscribe((data) => {
        // //console.log(data);

        if (data.length == 0) {
          this.boletos = data;
          data = '';
          this.mensajeError = 'Boleto(s) no disponible(s)';
          this.Error = true;
          this.box.hidden = false;
        } else {
          this.boletos = data;
          this.Error = false;
          this.box.hidden = false;
        }
        // //////console.log(JSON.stringify(data))
      });
      //////console.log("Seleccione opcion 3")
    } else if (opcion4 != '') {
      this.miSeleccion = { numero: opcion4, mecanismo: 'option_full_number', data: "47F422062D08C8FA6F726F7E0FF5E1C57D903CA62BD39006" };
      this._HomeService.seleccioGeneral(this.miSeleccion).subscribe((data) => {
        //////console.log(data.length)
        if (data.length == 0) {
          // //console.log(data);

          this.boletos = data;
          data = '';
          this.mensajeError = 'Boleto(s) no disponible(s)';
          this.Error = false;
          this.ErrorSuerte = true;
          this.box.hidden = false;
        } else {
          this.boletos = data;
          //////console.log(this.boletos);
          this.Error = false;
          this.ErrorSuerte = false;
          this.box.hidden = false;
        }
      });
      //////console.log("Seleccione opcion 4")
    }

  }






}
